'use strict';

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DependenciesContent = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _dec, _class, _dec2, _class3, _class4, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _shared = require('./shared');

var _util = require('../util');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = function styles(theme) {
  return {
    root: {
      lineHeight: 2.75,
      textAlign: 'left'
    },
    span: {
      borderTop: [['0.2em', 'solid', theme.labels.HEAD]],
      borderTopLeftRadius: '0.2em',
      borderTopRightRadius: '0.2em',
      margin: [[0, '0.2em']],
      padding: [['0.5em', 0, '0.25em']],
      position: 'relative'
    },
    spanText: {
      margin: [[0, '0.2em']],
      position: 'relative'
    },
    mark: {
      background: theme.labels.HEAD,
      position: 'relative',
      padding: [['0.5em', '0.4em', '0.25em']],
      '&:first-child': {
        margin: [[0, '0.2em', 0, 0]]
      },
      '&:last-child': {
        margin: [[0, 0, 0, '0.2em']]
      }
    },
    child: {
      background: theme.labels.CHILD,
      '&:after': {
        content: '""',
        width: 0,
        height: 0,
        border: [['0.4em', 'solid', 'transparent']],
        borderBottomWidth: 0,
        borderTopColor: theme.labels.HEAD,
        position: 'absolute',
        top: 0,
        left: 'calc(50% - 8px)'
      }
    },
    label: {
      position: 'absolute',
      top: -11,
      left: 0,
      fontWeight: 'bold',
      fontSize: '0.7em',
      fontFamily: theme.fontSecondary,
      zIndex: 10,
      padding: [['0.1em', '0.25em', '0.1em']],
      background: theme.labels.CHILD,
      color: 'inherit',
      margin: [[0, '0.25em']],
      borderRadius: '0.4em',
      border: [['0.15em', 'solid', theme.labels.HEAD]]
    }
  };
};

var DependenciesContent = exports.DependenciesContent = (_dec = (0, _util.withStyles)(styles), _dec(_class = function (_React$Component) {
  _inherits(DependenciesContent, _React$Component);

  function DependenciesContent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DependenciesContent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DependenciesContent.__proto__ || Object.getPrototypeOf(DependenciesContent)).call.apply(_ref, [this].concat(args))), _this), _this.getTokens = function () {
      var tokens = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return tokens.map(function (_ref2) {
        var text = _ref2.text,
            id = _ref2.id;
        return (// important: note space before </span>
          _react2["default"].createElement('span', {
            key: id
          }, (0, _util.replaceWsChar)(text, _shared.Char, _this.props.showWhitespace), ' ')
        );
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DependenciesContent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          classes = _props.classes,
          content = _props.content;
      var tokens = content.tokens,
          arcs = content.arcs;
      var arc = arcs[0];
      var start = Math.min(arc.head, arc.child);
      var end = Math.max(arc.head, arc.child);
      var beforeTokens = this.getTokens(tokens.slice(0, start));
      var afterTokens = this.getTokens(tokens.slice(end + 1));
      var innerTokens = this.getTokens(tokens.slice(start + 1, end));
      return _react2["default"].createElement(_react.Fragment, null, beforeTokens, start == end ? _react2["default"].createElement(_shared.Mark, {
        className: classes.mark
      }, tokens[start].text, _react2["default"].createElement('span', {
        className: classes.label
      }, 'ROOT')) : _react2["default"].createElement('span', {
        className: classes.span
      }, _react2["default"].createElement(_shared.Mark, {
        className: (0, _classnames2["default"])(classes.mark, _defineProperty({}, classes.child, arc.child == start))
      }, tokens[start].text, arc.head == start && _react2["default"].createElement('span', {
        className: classes.label
      }, arc.label)), _react2["default"].createElement('span', {
        className: classes.spanText
      }, innerTokens), _react2["default"].createElement(_shared.Mark, {
        className: (0, _classnames2["default"])(classes.mark, _defineProperty({}, classes.child, arc.child == end))
      }, tokens[end].text, arc.head == end && _react2["default"].createElement('span', {
        className: classes.label
      }, arc.label))), afterTokens);
    }
  }]);

  return DependenciesContent;
}(_react2["default"].Component)) || _class);
var Dependencies = (_dec2 = (0, _util.withStyles)(styles), _dec2(_class3 = (_temp2 = _class4 = function (_React$Component2) {
  _inherits(Dependencies, _React$Component2);

  function Dependencies() {
    _classCallCheck(this, Dependencies);

    return _possibleConstructorReturn(this, (Dependencies.__proto__ || Object.getPrototypeOf(Dependencies)).apply(this, arguments));
  }

  _createClass(Dependencies, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          content = _props2.content,
          config = _props2.config,
          nowrap = _props2.nowrap,
          classes = _props2.classes,
          children = _props2.children;
      var textSize = (0, _util.getTextSize)(content.text);
      return _react2["default"].createElement(_react.Fragment, null, _react2["default"].createElement(_shared.Content, {
        cardStyle: config.cardStyle,
        textSize: textSize,
        nowrap: nowrap
      }, _react2["default"].createElement('div', {
        className: classes.root
      }, _react2["default"].createElement(DependenciesContent, {
        content: content,
        showWhitespace: config.showWhitespace
      }))), children);
    }
  }]);

  return Dependencies;
}(_react2["default"].Component), _class4.id = 'dep', _temp2)) || _class3);
exports["default"] = Dependencies;